import React from 'react';
import { Send } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 bg-brand-dark relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-black text-white mb-4">Let's Work <span className="text-brand-magenta">Together</span></h2>
          <p className="text-gray-400">Fill out the form below and let's start creating viral content today.</p>
        </div>

        <div className="bg-brand-darker border border-brand-magenta/20 p-8 md:p-12 rounded-3xl shadow-2xl">
          {/* BURADAKİ ACTION KISMINA YENİ ID'Nİ YAZ */}
         <form 
    action="https://formspree.io/f/mnjbbnwr" 
    method="POST" 
    className="space-y-6"
>
  {/* Diğer inputlarda name="..." etiketlerinin olduğundan emin ol */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Full Name */}
              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Full Name *</label>
                <input 
                  type="text" 
                  name="name"
                  required
                  placeholder="John Doe"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-600 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Email Address *</label>
                <input 
                  type="email" 
                  name="email"
                  required
                  placeholder="john@example.com"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-600 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Business Type */}
              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Business Type *</label>
                <input 
                  type="text" 
                  name="business_type"
                  required
                  placeholder="e.g. Creator, Agency, E-com"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-600 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                />
              </div>

              {/* Monthly Content Goal */}
              <div>
                <label className="block text-sm font-bold text-gray-300 mb-2">Monthly Content Goal *</label>
                <select 
                  name="goal"
                  required
                  className="w-full bg-brand-darker border border-white/10 rounded-xl px-5 py-4 text-white focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all appearance-none"
                  style={{ backgroundColor: '#0A0A0A' }}
                >
                  <option value="" disabled selected>Select your goal</option>
                  <option value="1-5">1-5 Videos</option>
                  <option value="5-15">5-15 Videos</option>
                  <option value="15-30">15-30 Videos</option>
                  <option value="30+">30+ Videos</option>
                </select>
              </div>
            </div>

            {/* Message Area */}
            <div>
              <label className="block text-sm font-bold text-gray-300 mb-2">Tell us about your goals (Optional)</label>
              <textarea 
                name="message"
                rows="4"
                placeholder="What kind of content are you creating? What are your growth goals?"
                className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-600 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all resize-none"
              ></textarea>
            </div>

            <button 
              type="submit"
              className="w-full py-5 rounded-2xl font-black text-lg transition-all duration-300 flex items-center justify-center gap-3 group border-2 border-white text-white hover:bg-brand-magenta hover:border-brand-magenta hover:text-white hover:shadow-[0_0_20px_rgba(247,106,195,0.4)] active:scale-95"
            >
              Send Message
              <Send size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </button>
            
            <p className="text-center text-xs text-gray-500 mt-4">
              We'll respond within 24 hours. Your information is secure.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;